import { getContext } from '@fiverr-private/fiverr_context';

export const isRisingTalent = (isHandpicked) => {
    const { queryParameters } = getContext();

    return isHandpicked && queryParameters.rising_talent;
};
